import React from "react";
import DefaultLayout from "Containers/Layout/DefaultLayout";
import Title from "Pages/Components/Title";
import { DonateHero } from "Pages/CheckoutV2";
import DonateSection from "Pages/Components/CheckoutV2/DonateSection";
import FooterV2 from "Pages/Components/CheckoutV2/FooterV2";
import "../i18n/config";
import { useTranslation } from "react-i18next";

/**
 * CheckoutV3 is identical to {@link CheckoutV2}; the only difference is that the
 * donation form's "Your Information" block is rendered below the "Choose
 * Donation Amount" block (driven by the `infoBelowAmount` prop on
 * {@link DonateSection}). Everything else — hero, summary, footer — is shared.
 */
const CheckoutV3 = () => {
  const { t } = useTranslation();

  return (
    <>
      <Title value={t("donationPage.title")} />

      <DefaultLayout
        disablePlayer
        disableFooter
        disableBanner
        disableNavItems
        disableDonateButton
        donationPageV2
      >
        <DonateHero />
        <DonateSection infoBelowAmount />
        <FooterV2 />
      </DefaultLayout>
    </>
  );
};

export default CheckoutV3;
